import { render, staticRenderFns } from "./TopCountries.vue?vue&type=template&id=95986fa4"
import script from "./TopCountries.vue?vue&type=script&lang=js"
export * from "./TopCountries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports